import "./UnderwritingSteps.scss";

import { FC } from "react";

import ProgressStep, { ProgressStepProps } from "components/ProgressStep/ProgressStep";
import Text from "components/Text/Text";
import { useTranslation } from "modules";

const UnderwritingSteps: FC = () => {
  const { t } = useTranslation();

  const underwritingStepItem: UnderwritingStepsItem[] = [
    {
      progress: "completed",
      title: t("underwriting-steps.one.title", "Get an estimate"),
    },
    {
      progress: "completed",
      title: t("underwriting-steps.two.title", "Submit your application"),
    },
    {
      body: t(
        "underwriting-steps.three.body",
        "We are securely reviewing your application and working on getting you the best price possible."
      ),
      progress: "current",
      title: t("underwriting-steps.three.title", "Underwriting Application"),
    },
    {
      body: t(
        "underwriting-steps.four.body",
        "Once it is finalized, simply accept your quote and setup your billing to start your coverage."
      ),
      progress: "upcoming",
      title: t("underwriting-steps.four.title", "Review & Accept your Quote"),
    },
  ];

  return (
    <div className="underwriting-steps">
      {underwritingStepItem.map(({ body, progress, title }, index) => (
        <ProgressStep key={index} progress={progress}>
          <Text tag="l4" text={title} />
          <Text className="underwriting-steps__body" tag="b5" text={body} />
        </ProgressStep>
      ))}
    </div>
  );
};

export default UnderwritingSteps;

type UnderwritingStepsItem = {
  progress: ProgressStepProps["progress"];
  title: string;
  body?: string;
};
